import { render, staticRenderFns } from "./addRoleView.vue?vue&type=template&id=99cad4b6&scoped=true&"
import script from "./addRoleView.vue?vue&type=script&lang=js&"
export * from "./addRoleView.vue?vue&type=script&lang=js&"
import style0 from "./addRoleView.vue?vue&type=style&index=0&id=99cad4b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cad4b6",
  null
  
)

export default component.exports